import { SURVEY_EDITOR_ADD_IMAGES_FROM_LIBRARY } from "../../../../../constants";

export const handleAddImage = (payload) => {
    return (dispatch) => {
        dispatch({ type: SURVEY_EDITOR_ADD_IMAGES_FROM_LIBRARY, payload });
    }
};